import api from './api';

export default {
  getReports() {
    return new Promise((resolve, reject) => {
      api
        .post('reports', {})
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  downloadReport(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`reports/${id}/download`, { responseType: 'blob' })
        .then(response => resolve(response))
        .catch(error => reject(error.data));
    });
  }
};
